import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { routeSwap } from '../core/animations';

@Component({
  selector: 'atm-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [routeSwap],
})
export class HomeComponent {
  readonly environmentName = environment.name;

  mediumScreenState: Observable<BreakpointState>;

  constructor(breakpointObserver: BreakpointObserver) {
    this.mediumScreenState = breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
    ]);
  }

  prepareRouterAnimation(outlet: RouterOutlet): string | undefined {
    return (
      outlet?.activatedRouteData && outlet?.activatedRouteData['animation']
    );
  }

  prepareRouterTheme(outlet: RouterOutlet): string | undefined {
    return outlet?.activatedRouteData && outlet?.activatedRouteData['theme'];
  }
}
